module.exports = __webpack_public_path__ + "static/media/like.0368cc15.svg";